import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
declare var echarts;//设置echarts全局对象

@Component({
  selector: 'app-mz-slide-echarts',
  templateUrl: './mz-slide-echarts.component.html',
  styleUrls: ['./mz-slide-echarts.component.scss']
})

export class MzSlideEchartsComponent extends GridBaseCase {

  constructor() { super(); }

  @ViewChild('echartsContent') container: ElementRef;//与html中div #container1对应
  // @ViewChild('echartsContent2') container2: ElementRef;//与html中div #container1对应
  EChart: any;
  // echart2: any;
  ngOnInit() {
    const that = this;
    this.echartBind();
    window.addEventListener('resize',function(){
      that.EChart.resize();
    });
  }
  echartBind() {
    let ctelement = this.container.nativeElement;
    this.EChart = echarts.init(ctelement);
    let options = {
      backgroundColor: null,
      color: ['#f9f8fe', '#5a7cdb'],
      series: [{
        name: '新客',
        type: 'pie',
        radius: ['80%', '90%'],
        avoidLabelOverlap: false,
        hoverAnimation: false,
        label: {
          normal: {
            show: false,
            position: 'center',
            textStyle: {
              fontSize: 12,
              color: '#fff',
              fontWeight: 'bold'
            },
            formatter: function () {
              return "达成率90%"
            }
          }
        },
        data: [{
          value: 90,
          name: '及格率',
          label: {
            normal: {
              show: true
            }
          }
        },
        {
          value: 100 - 90,
          name: ''
        }
        ]
      }]
    };
    this.EChart.setOption(options);
  }
  onResize() {
    this.EChart.resize();
  }

}
